import React from 'react';
import { NodeProps } from 'components/canvas/components/nodes/components/base-node';
import TextNode from 'components/canvas/components/nodes/components/text-node';

interface DocumentSnippetNodeProps extends NodeProps {}

function DocumentSnippetNode(props: DocumentSnippetNodeProps) {
  return <TextNode {...props} />;
}

export default DocumentSnippetNode;
